import PropTypes from 'prop-types';
import { CatTableObject } from '@blocks-react/components/TableObject';
import { CatTable } from '@blocks-react/components/Table';
import styles from './ShareListDrawerTableContainer.module.scss';

const ShareListDrawerTableContainer = ({ children }) => {
  return (
    <div className="cat-u-margin-top-md">
      <CatTableObject className={`${styles['share-list__table-body-height']}`}>
        <CatTable>{children}</CatTable>
      </CatTableObject>
    </div>
  );
};

ShareListDrawerTableContainer.propTypes = {
  children: PropTypes.node
};
export default ShareListDrawerTableContainer;
